import KitsilanoOrderRepository from './acadia/kitsilano/orders/orderRepository';
import KitsilanoOrderStatusRepository from './acadia/kitsilano/orders/orderStatusRepository';
import D365ReturnRepository from './acadia/d365/returnAuthorizationRepository';
import ShopifyPriceRuleRepository from './acadia/shopify/discounts/priceRuleRepository';
import ShopifyOrderRepository from './acadia/shopify/orders/orderRepository';
import ShopifyOrderRefundRepository from './acadia/shopify/orders/refundRepository';
import ShopifyProductRepository from './acadia/shopify/products/productRepository';
import ShopifyShippingZoneRepository from './acadia/shopify/storeProperties/shippingZoneRepository';
import OCAEditHistoryRepository from './acadia/orderChangeApp/editHistoryRepository';
import D365OrderRepository from './acadia/d365/orderRepository'

const repositories = {
  'acadia/kitsilano/orders/order': KitsilanoOrderRepository,
  'acadia/kitsilano/orders/order-status': KitsilanoOrderStatusRepository,
  'acadia/d365/return': D365ReturnRepository,
  'acadia/d365/order': D365OrderRepository,
  'acadia/shopify/discounts/price-rule': ShopifyPriceRuleRepository,
  'acadia/shopify/orders/order': ShopifyOrderRepository,
  'acadia/shopify/orders/refund': ShopifyOrderRefundRepository,
  'acadia/shopify/products/product': ShopifyProductRepository,
  'acadia/shopify/store-properties/shipping-zone': ShopifyShippingZoneRepository,
  'acadia/oca/edit-history': OCAEditHistoryRepository,
};

export const RepositoryFactory = {
  get: name => repositories[name],
};
